import { FunctionComponent } from 'react';
import { CellProps } from 'components/tables/cells';
import VerticalStackCell from './VerticalStackCell';
import { useGlobalContext } from 'components/common/GlobalContext/GlobalContext';
import { Text } from '@montel/montelpro-shared-components-v2';
import { PermissionSet } from 'domain/subscription/interfaces/Subscription';

export interface PlanCellProps extends CellProps {
	permissionSets: Record<string, PermissionSet>;
	applicationId?: string;
}

const PlanCell: FunctionComponent<PlanCellProps> = ({
	permissionSets,
	applicationId,
	...rest
}) => {
	const { getPlanByCode } = useGlobalContext();

	if (applicationId) {
		const permissionSet = permissionSets[applicationId];
		const plan = getPlanByCode(applicationId, permissionSet?.plan || '');

		return <Text size={'sm'}>{plan?.displayName || 'N/A'}</Text>;
	}

	return (
		<VerticalStackCell {...rest}>
			{Object.keys(permissionSets).map((appId) => {
				const plan = getPlanByCode(appId, permissionSets[appId].plan);
				return (
					<Text key={appId} size={'sm'}>
						{plan?.displayName || 'N/A'}
					</Text>
				);
			})}
		</VerticalStackCell>
	);
};

export default PlanCell;
